import React, {useState, useEffect} from "react";
import {API} from './api-service';
import  {useCookies, setCookie}from "react-cookie"
import Modal from 'react-bootstrap/Modal';
import { FadeLoader } from "react-spinners";

function Login(){

    const [username, setUsername] = useState ('');
    const [password, setPassword] = useState ('');
    const [incorrect, setIncorrect] = useState(false);
    const [loading, setLoading] = useState(false);
    const [connected, setConnected] = useState(true);
    const [token, setToken] = useCookies(['pn-token']);
    

    useEffect( () => {
        if (token['pn-token']) {
            API.checkUser(token['pn-token'])
            .then(resp => resp?
                (resp.status?
                    (window.location.href = '/', console.log(resp.status))
                    :
                    (//removeToken('pn-token'), 
                    console.log(resp))
                )
                :
                (setConnected(false), console.log("No response"))
            )
        }
    },[token])

    const handleSubmit = (evt) => {
        evt.preventDefault();
        setLoading(true);
        API.loginUser({username, password})
        .then (resp => {
            if(resp?.token){
                setToken('pn-token', resp.token, {'sameSite':false});
                setIncorrect(false);
            }
            else{
                setIncorrect(true);
                setPassword("");
            }
            setLoading(false);
        })
    }

    const registerClicked = (evt) => {
        evt.preventDefault();
        window.location.href = "/register"
    }

    return (
        <div style={{height:"100vh"}}>
            <header className="App-header" style={{height: "calc(2em + 2.5vh)", backgroundImage: "linear-gradient(to right, #2B6DFE , #00F2FF)"}}>
                <span/>
                <h1 className='App-title'>Phleb-O-Nurse</h1>
                <span/>
            </header>
            <div style={{height: "100%", display: "grid", gridTemplateRows: "1fr 2.1fr"}}>
                <div style={{backgroundImage: "linear-gradient(to right, #2B6DFE , #00F2FF)"}}></div>
                <div style={{background: "#72BA59"}}></div>
            </div>
        <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show="true"
        backdropClassName="backdrop"
        //size="lg"
        >
            <Modal.Header style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundImage: "linear-gradient(to right, #2B6DFE , #00F2FF)",
                color: "white",
                border: "0px",
                borderRadius: "10px 10px 0px 0px"
            }}>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h1 className="login-header">Login</h1>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{backgroundColor: "#FFFBD8", paddingTop: "40px", borderRadius: "0px 0px 10px 10px"}}>
                {connected?
                    <form className="login-form" onSubmit={handleSubmit}>
                        <label>Username</label>
                        <input  id='username' type='text' placeholder="Username" value={username}
                            onChange={evt => {setUsername(evt.target.value); setIncorrect(false);}} required/> 
                        <label>Password</label>
                        <input  id='password' type='password' placeholder="Password" value={password}
                            onChange={evt => {setPassword(evt.target.value); setIncorrect(false);}} required/> 
                        <div/>
                        <p style={{color:"red"}}>{incorrect? "Your username or password is incorrect.":""}</p>
                        <div/>
                        {loading?
                            <FadeLoader cssOverride={{margin:"-25px auto", left: "100px"}}/>:
                            <input className="btn btn-login btn-primary" type="submit" value=" Login "/>
                            
                        }
                        <div/>
                        <a className="btn btn-login btn-primary" href="/insurer">Insurer Login</a>
                        <span/>
                        <button className="btn btn-login btn-primary" onClick={registerClicked}>Create Account</button>
                    </form>:
                    <p>Error: failed to connect to server</p>
                }
                
            </Modal.Body>
        </Modal>
        </div>
    )

}


export default Login;